var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-weather"},[_c('div',{staticClass:"header-item"},[_c('img',{staticClass:"item-icon",attrs:{"src":require("../../assets/image/icon_address.png")}}),_c('span',{staticClass:"item-content address"},[_vm._v("南宁")])])])
}]

export { render, staticRenderFns }